<template>
  <div class="rate-wrap">
    <div
      v-for="(item, index) in smileItems"
      :key="index"
      class="item"
      :class="{ 'active': value === index + 1 }"
    >
      <div 
      class="smile-icon"
      @mousedown="handleMouseDown(index + 1)"
      @mouseup="handleMouseUp(index + 1)"
      @touchstart="onTouchStart(index + 1, $event)"
      @touchmove="onTouchMove"
      @touchend="onTouchEnd(index + 1)">
        <img 
          :src="value === index + 1 ? getActiveImage(index) : getInactiveImage(index)" 
          :alt="item.label"
        />
      </div>
      <div class="smile-label">
        {{ $t(item.labelKey) }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Rate',
  props: {
    value: {
      type: Number,
      default: 0
    },
    pIndex: {
      type: Number,
      default: 0
    },
    total: {
      type: Number,
      default: 0
    },
    list: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      ranges: [],
      touchStartX: 0,
      touchStartY: 0,
      isScrolling: false,
      scrollThreshold: 10, // 滑动阈值(像素)
      // 定义5个笑脸等级
      smileItems: [
        { labelKey: 'VeryDissatisfied' },
        { labelKey: 'Dissatisfied' },
        { labelKey: 'Neutral' },
        { labelKey: 'Satisfied' },
        { labelKey: 'VerySatisfied' }
      ]
    }
  },
  methods: {
    select (value) {
      if (this.isScrolling) return;
      const newValue = this.value === value ? value : value;
      this.$emit('input', newValue);
      this.$emit('change', newValue);
    },
    
    handleMouseDown (value) {
      this.isScrolling = false;
    },
    
    handleMouseUp (value) {
      this.select(value);
    },
    
    onTouchStart (value, event) {
      this.touchStartX = event.touches[0].clientX;
      this.touchStartY = event.touches[0].clientY;
      this.isScrolling = false;
      
      // 立即获取位置信息
      const items = this.$el.querySelectorAll('.item');
      const ranges = [];
      items.forEach((item, index) => {
        const rect = item.getBoundingClientRect();
        ranges.push({ 
          score: index + 1, 
          left: rect.left,
          right: rect.right 
        });
      });
      this.ranges = ranges;
    },

    onTouchMove (event) {
      if (!this.touchStartX) return;

      const touchX = event.touches[0].clientX;
      const touchY = event.touches[0].clientY;

      // 检查是否达到滑动阈值
      if (!this.isScrolling &&
        (Math.abs(touchX - this.touchStartX) > this.scrollThreshold ||
          Math.abs(touchY - this.touchStartY) > this.scrollThreshold)) {
        this.isScrolling = true;
      }

      if (this.isScrolling) {
        this.select(this.getScoreByPosition(touchX));
      }
    },

    onTouchEnd (value) {
      if (!this.isScrolling) {
        this.select(value);
      }
      this.touchStartX = 0;
      this.touchStartY = 0;
      this.isScrolling = false;
    },
    getScoreByPosition (x) {
      for (let i = this.ranges.length - 1; i >= 0; i--) {
        if (x >= this.ranges[i].left && x <= this.ranges[i].right) {
          return this.ranges[i].score;
        }
      }
      // 如果超出范围，返回最接近的项
      if (x < this.ranges[0].left) return 1;
      if (x > this.ranges[this.ranges.length - 1].right) return this.ranges.length;
      return 0;
    },
    // 获取未选中状态的图片
    getInactiveImage (index) {
      const images = [
        require('../assets/images/verydissatisfied_gray.png'),
        require('../assets/images/dissatisfied_gray.png'),
        require('../assets/images/generally_gray.png'),
        require('../assets/images/satisfied_gray.png'),
        require('../assets/images/verysatisfied_gray.png')
      ];
      return images[index] || images[0];
    },
    // 获取选中状态的图片
    getActiveImage (index) {
      const images = [
        require('../assets/images/verydissatisfied_green.png'),
        require('../assets/images/dissatisfied_green.png'),
        require('../assets/images/generally_green.png'),
        require('../assets/images/satisfied_green.png'),
        require('../assets/images/verysatisfied_green.png')
      ];
      return images[index] || images[0];
    }
  }
}
</script>
<style scoped lang="less">
.rate-wrap {
  display: flex;
  flex: 1;
  margin-right: 30px;
  justify-content: space-between;

  .item {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 0 5px;
    cursor: pointer;

    .smile-icon {
      width: 80px;
      height: 80px;
      margin-bottom: 10px;
      
      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }

    .smile-label {
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 24px;
      color: #86949E;
      line-height: 33px;
      font-style: normal;
    }

    &.active {
      .smile-label {
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 24px;
      color: #36444E;
      line-height: 33px;
      font-style: normal;
      }
    }
  }
}
</style>